<template>
  <div class="max-w-screen-sm mx-auto min-h-screen w-full">
    <!-- First screen -->
    <section v-show="step == 0"
      class="flex flex-col items-center justify-center bg-[url(/img/bg.jpg)] z-10 h-full relative overflow-hidden">
      <div class="h-screen w-screen overflow-hidden">
        <div class="bg-[url(/img/landing/0-cielo.webp)] landing"
          :class="loading <= 2 ? 'animate-parallax-1' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/1-calle.webp)] landing" @click="step++"
          :class="loading <= 2 ? 'animate-parallax-1' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/2-parque.webp)] landing" @click="step++"
          :class="loading <= 2 ? 'animate-parallax-1' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/3-casona.webp)] landing" @click="step++"
          :class="loading <= 1 ? ' animate-parallax-2' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/4-capilla.webp)] landing" @click="step++"
          :class="loading <= 1 ? ' animate-parallax-2' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/5-palmeras.webp)] landing" @click="step++"
          :class="loading <= 1 ? ' animate-parallax-2' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/6-luces.webp)] landing" @click="step++"
          :class="loading <= 1 ? ' animate-parallax-2' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/7-carros.webp)] landing" @click="step++"
          :class="loading <= 1 ? 'animate-parallax-2' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/8-pileta.webp)] landing" @click="step++"
          :class="loading <= 1 ? 'animate-parallax-2' : '-translate-y-full'"></div>
        <div class="bg-[url(/img/landing/9-booth.webp)] landing" @click="step++"
          :class="loading <= 0 ? 'animate-parallax-3' : '-translate-y-full'"></div>
          <img src="/img/logo.png" alt="" class="absolute top-12 h-24 inset-x-0 mx-auto">
        <video autoplay playsinline muted src="/img/video.mp4"
          class="mix-blend-screen absolute top-1/3 animate-bounce inset-x-0 w-32 left-1/3"></video>
      </div>
      <div
        class="absolute inset-0 bg-red-600/50 backdrop-blur-sm flex flex-col items-center justify-center overflow-hidden"
        v-if="loading">
        <img src="/img/loading-logo.png" alt="Logo PhotoBooth" class="h-1/2 origin-top animate-swing -mt-10">
        <div class="text-white text-center grow flex flex-col items-center justify-center">
          <h2 class="text-4xl font-bold">Cargando experiencia...</h2>
          <p class="text-xl mt-4">Por favor espera unos segundos</p>
        </div>
        <progress
          class="w-1/2 mt-8 rounded-md [&::-webkit-progress-bar]:rounded-lg [&::-webkit-progress-value]:rounded-lg   [&::-webkit-progress-bar]:bg-slate-300 [&::-webkit-progress-value]:bg-red-800 [&::-moz-progress-bar]:bg-red-800 [&::-webkit-progress-value]:transition-all [&::-webkit-progress-value]:duration-500"
          min="0" max="3" :value="3 - loading"></progress>
        <!-- <img src="/img/wemake-badge.svg" alt="Logo WM" class="mt-32 h-16 bg-black rounded-lg mx-auto"> -->
        <div class="grow"></div>
      </div>
    </section>

    <!-- Instructions -->
    <section v-show="step == 1"
      class="bg-[url(/img/bg.jpg)] min-h-screen px-4 sm:px-10 text-center flex flex-col items-center pt-4 gap-4 pb-10">
      <div>
        <h2 class="text-red-700 font-bold text-xl">Bienvenido al</h2>
        <img src="/img/logo.png" alt="" class="mt-2 px-12 sm:px-4">
      </div>
      <div
        class="bg-white border-4 border-b-[0.5rem] border-red-700 px-4 sm:px-8 py-4 sm:py-10  rounded-lg flex flex-col justify-center items-center -rotate-3 mt-4 sm:mt-10">
        <h3 class="text-xl font-bold">
          ¿Te imaginas pasar un San Valentín especial?
        </h3>

        <p class="mt-4 text-sm">
          ¡Es más fácil de lo que crees! Para esta experiencia solo necesitarás una foto tuya y una de tu pareja
          para teletransportarse a lugares únicos y llevarse un recuerdo inolvidable.
        </p>

        <p class="mt-8 text-gray-600 text-xs">
          No te preocupes, no guardaremos ninguna foto. Además, funciona incluso sin conexión.
        </p>
        <div class="grow"></div>

        <button class="btn btn-primary mt-4 w-full" @click="step++">Empezar</button>
      </div>
    </section>


    <!-- Take pictures -->
    <section id="" class="relative bg-[url(/img/bg.jpg)] min-h-screen" v-show="step == 2 || step == 3 || step == 4">
      <div class="flex flex-col h-full">
        <div class=" pt-4 sm:pt-8 pb-4 flex flex-col items-center justify-center">
          <h2 class="text-xl sm:text-5xl text-red-700 font-bold text-center inset-x-0 z-20">{{ text }}</h2>

          <div class="flex gap-4">
          <canvas id="p1Canvas"
            class="object-cover h-32 sm:h-48 w-24 rotate-6 drop-shadow-lg rounded-md bg-red-200 border-white border-2"
            width="1080" height="1080"></canvas>
          <canvas id="p2Canvas"
            class="object-cover h-32 sm:h-48 -rotate-12 w-24 right-1 drop-shadow-lg rounded-md bg-red-200 border-white border-2"
            width="1080" height="1080"></canvas>
          </div>

          <button class="btn btn-primary mx-10 mt-5 w-1/2" @click="startPhotoBooth()" v-if="!stream">Abrir
            cámara</button>
        </div>
        <div class="flex grow shrink-0" v-show="stream">
          <!-- left pane -->
          <div class="grow"></div>
          <div class="shrink-0 relative min-h-16 sm:min-h-32 rounded-lg overflow-hidden border-4 border-red-800"
            style="width: 50%">
            <canvas id="localVideoCanvas" class="absolute inset-0 w-full h-full object-cover bg-blue-500"
              :class="freeze ? 'opacity-50' : ''" width="500" height="750"></canvas>
            <video src="" id="localVideo" autoplay playsinline muted class="bg-red-800 h-2"></video>
          </div>
          <!-- right pane -->
          <div class="grow"></div>
        </div>
        <div class="py-4 sm:py-10 text-center px-2 sm:px-10 grow pb-24">
          <button @click="captureCanvas" class="btn btn-primary w-3/4 mb-4" v-show="stream">Tomar foto</button>
          <div class="flex gap-4 items-center px-10">
            <hr class="h-px grow border-red-800">
            <div>
              o elige una foto
            </div>
            <hr class="h-px grow border-red-800">
          </div>
          <div class="grid grid-cols-4 lg:grid-cols-4 gap-2 sm:gap-4 mt-5 mb-2">
            <button v-for="person in famous" :key="person.name" class="btn btn-secondary px-1" @click="selectFamousPerson(person.img)">
              <img :src="person.img" :alt="person.name" class="w-16 h-16 sm:h-20 sm:w-20 rounded-full object-cover mx-auto">
            </button>

            <button class="btn btn-secondary col-span-4" @click="selectPictureFromGallery">Sube una foto</button>
          </div>
        </div>
      </div>
    </section>

    <!-- Processing... -->
    <section v-if="step == 5"
      class="bg-[url(/img/bg.jpg)] h-screen px-2 sm:px-10 text-center flex flex-col items-center justify-center gap-4 text-red-900">
      <h3 class="font-bold text-3xl" v-if="processingStep == 0">
        Teletransportando...
      </h3>
      <h3 class="font-bold text-3xl" v-if="processingStep == 1">
        Colocando caritas...
      </h3>
      <h3 class="font-bold text-3xl" v-if="processingStep == 2">
        Imprimiendo...
      </h3>
    </section>


    <!-- Printing -->
    <section class="bg-red-700 h-screen relative px-4" v-show="step == 6">
      <div class="bg-[url(/img/printer.png)] h-full bg-center bg-contain bg-no-repeat mx-10"></div>
      <div class="absolute left-[20%] top-[32%] right-[20%] bottom-[10%] overflow-hidden">
        <div
          class="flex flex-col py-[10%] bg-white rounded-lg shadow-xl absolute w-[30%] inset-x-0 mx-auto transition-all duration-500"
          :class="print ? 'translate-y-0': '-translate-y-[120%]'">
          <div id="photo_1" class="bg-gray-800 w-full"></div>
          <div id="photo_2" class="bg-gray-800 w-full"></div>
          <div id="photo_3" class="bg-gray-800 w-full"></div>
          <div id="photo_4" class="bg-gray-800 w-full"></div>
        </div>
      </div>

      <div class="">
        <button class="btn btn-secondary inset-x-8 absolute bottom-24 py-2 text-xl" @click="step++">
          Ver fotos
        </button>
      </div>
    </section>

    <section
      class="bg-red-600 min-h-screen flex flex-col items-center justify-center px-10 pt-4 gap-2 pb-32 overflow-hidden"
      v-show="step == 7">
      <canvas id="outputCanvas" class="bg-black w-full rounded-lg"
        :class="step == 7 ? 'animate-sbinalla' : ''"></canvas>
      <button class="btn btn-primary w-full mt-4" @click="shareToIg">Compartir en IG</button>
      <button class="btn btn-secondary w-full" @click="startOver">Volver a empezar</button>
      <div class="grow"></div>
    </section>


  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { setupFindFace } from '../face-recognition';
import { setupFaceSegmentation } from '../face-segmentation';
import { drawAtAngle, drawRandomOutput, takeScreenshot } from '../canvas-painter';

export default defineComponent({
  data() {
    return {
      step: 0,
      interval: null,
      print: false,
      freeze: false,
      text: "¡Toma o elige una foto!",
      loading: 3,
      started: false,
      stream: null,
      processingStep: 0,
      famous: [
        {
          name: 'Dua Lipa',
          img: '/img/famous/dua-2.webp'
        },
        {
          name: 'Cristiano Ronaldo',
          img: '/img/famous/cristiano.webp'
        },
        {
          name: 'Billie Eilish',
          img: '/img/famous/billie.webp'
        },
        {
          name: 'Brad Pitt',
          img: '/img/famous/brad-2.webp'
        },
        {
          name: 'Bruno Mars',
          img: '/img/famous/bruno.webp'
        },
        {
          name: 'Tia Susy',
          img: '/img/famous/susy.webp'
        },
        {
          name: 'Shrek',
          img: '/img/famous/shrek.webp'
        },
        {
          name: 'Timothée Chalamet',
          img: '/img/famous/timothee.webp'
        },
        {
          name: 'Ryan',
          img: '/img/famous/ryan.webp'
        },
        {
          name: 'Ana de Armas',
          img: '/img/famous/ana.webp'
        },
        {
          name: "Alexandra",
          img: '/img/famous/alexandra.webp'
        },
        {
          name: "Andrew Garfield",
          img: '/img/famous/andrew.webp'
        },
        {
          name: "James Franco",
          img: '/img/famous/james.webp'
        },
        {
          name: "Chayanne",
          img: '/img/famous/chayanne.webp'
        },
        {
          name: "Francesca",
          img: '/img/famous/francesca.webp'
        },
        {
          name: "Joel",
          img: '/img/famous/joel.webp'
        },
        // {
        //   name: 'Stitch',
        //   img: '/img/famous/stitch.png'
        // },
        // {
        //   name: 'Angel',
        //   img: '/img/famous/angel.png'
        // },
        // {
        //   name: 'Bob esponja',
        //   img: '/img/famous/sponge-bob.png'
        // }
      ]
    };
  },
  mounted() {
    setTimeout(()=>{
      this.loading--;
      setupFindFace(() => {
        console.log("Find face loaded", this.loading);
        this.loading--;

        setTimeout(()=>{
          setupFaceSegmentation(() => {
            console.log("Face segmentation loaded", this.loading);
            this.loading--;
          });
        })
        this.resetCanvases();
      });

    }, 1000)



  },
  methods: {
    resetCanvases(){
      const p1Canvas = document.getElementById('p1Canvas') as HTMLCanvasElement;
      // write "Player 1" on the canvas
      let ctx = p1Canvas.getContext('2d');
      if (!ctx) return;
      ctx.clearRect(0, 0, p1Canvas.width, p1Canvas.height);
      ctx.font = "bold 256px Space Grotesk";
      ctx.fillStyle = "rgb(185 28 28)";
      ctx.textAlign = "center";
      ctx.fillText("P1", p1Canvas.width / 2, p1Canvas.height / 2 + 100);

      const p2Canvas = document.getElementById('p2Canvas') as HTMLCanvasElement;

      // write "Player 2" on the canvas
      let ctx2 = p2Canvas.getContext('2d');
      if (!ctx2) return;
      ctx2.clearRect(0, 0, p2Canvas.width, p2Canvas.height);
      ctx2.font = "bold 256px 'Space Grotesk'";
      ctx2.fillStyle = "rgb(185 28 28)";
      ctx2.textAlign = "center";
      ctx2.fillText("P2", p2Canvas.width / 2, p2Canvas.height / 2+100 );
    },
    startOver(){
      this.step = 1;
      this.print = false;
      this.freeze = false;
      this.text = "¡Toma o elige una foto!";
      this.started = false;
      this.processingStep = 0;
      // remove photos from canvas
      let photo1 = document.getElementById('photo_1') as HTMLElement;
      photo1.innerHTML = "";
      let photo2 = document.getElementById('photo_2') as HTMLElement;
      photo2.innerHTML = "";
      let photo3 = document.getElementById('photo_3') as HTMLElement;
      photo3.innerHTML = "";
      let photo4 = document.getElementById('photo_4') as HTMLElement;
      photo4.innerHTML = "";

      // clear p1Canvas and p2 Canvas and write the text again
      this.resetCanvases();

    },
    async startPhotoBooth() {
      if (this.started) return;
      this.started = true;
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'user',
          },
        }); 
      } catch (error) {
        console.error('Error accessing media devices.', error);
        return;
      };
      const localVideoEl = document.getElementById('localVideo') as HTMLVideoElement;
      if (!localVideoEl) { return }
      localVideoEl.srcObject = this.stream;

      setInterval(() => {
        if (this.freeze) return;
        const localVideoCanvas = document.getElementById('localVideoCanvas') as HTMLCanvasElement;
        let ctx = localVideoCanvas.getContext('2d');
        // depending on the source Width/height get the middle 1/1.5 frame
        let ratio = 1 / 1.5;
        let height = localVideoEl.videoHeight;
        localVideoCanvas.height = height * 0.7;
        localVideoCanvas.width = height * 0.7 * ratio;

        ctx?.drawImage(localVideoEl,
          (localVideoEl.videoWidth / 2) - ((localVideoEl.videoHeight * 0.7 * ratio) / 2), localVideoEl.videoHeight * 0.15,
          localVideoEl.videoHeight * 0.7 * ratio, // width
          localVideoEl.videoHeight * 0.7, // height
          0, 0, localVideoCanvas.width, localVideoCanvas.height);
      }, 1000 / 30)
    },
    selectFamousPerson(person: string){
      const img = new Image();
      img.src = `${person}`;
      img.onload = async() => {
        if (this.step == 2) {
          const p1Canvas = document.getElementById('p1Canvas') as HTMLCanvasElement;
          takeScreenshot(img, p1Canvas);
          this.step++; // step 3
          this.text = "Turno de tu pareja...";
        } else if (this.step == 3) {
          const p2Canvas = document.getElementById('p2Canvas') as HTMLCanvasElement;
          takeScreenshot(img, p2Canvas);
          this.step++; // step 4
          await new Promise((resolve) => setTimeout(resolve, 1000));
          this.drawOutput();
        }
      }
    },
    selectPictureFromGallery() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target?.result as string;
            img.onload = async() => {
              if (this.step == 2) {
                const p1Canvas = document.getElementById('p1Canvas') as HTMLCanvasElement;
                takeScreenshot(img, p1Canvas);
                this.step++; // step 3
                this.text = "Turno de tu pareja...";
              } else if (this.step == 3) {
                const p2Canvas = document.getElementById('p2Canvas') as HTMLCanvasElement;
                takeScreenshot(img, p2Canvas);
                this.step++; // step 4
                await new Promise((resolve) => setTimeout(resolve, 1000));
                this.drawOutput();
              }
            }
          }
          reader.readAsDataURL(file);
        }
      }
      input.click();
    },
    
    async captureCanvas() {
      if (this.step === 2) {
        const localVideoEl = document.getElementById('localVideoCanvas') as HTMLCanvasElement;
        const p1Canvas = document.getElementById('p1Canvas') as HTMLCanvasElement;
        takeScreenshot(localVideoEl, p1Canvas);
        this.freeze = true;
        window.setTimeout(() => {
          this.text = "Turno de tu pareja...";
          this.freeze = false;
        }, 500)
        this.step++;
      } else if (this.step === 3) {
        const localVideoEl = document.getElementById('localVideoCanvas') as HTMLCanvasElement;
        const p2Canvas = document.getElementById('p2Canvas') as HTMLCanvasElement;
        takeScreenshot(localVideoEl, p2Canvas);
        this.freeze = true;
        if (this.interval) {
          clearInterval(this.interval);
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.step++; // step 4
        this.text = "Ok...";
        this.drawOutput();
      }
    },

    async drawOutput() {
      this.step++; // step 5 processing

      this.processingStep = 0;

      this.stream?.getTracks().forEach((track) => {
        track.stop();
      });
      this.stream = null;

      // sleep for 300ms
      let output1 = await drawRandomOutput()
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.processingStep = 1;
      let output2 = await drawRandomOutput()
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.processingStep = 2;
      let output3 = await drawRandomOutput()
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.step++; // step 6: printing
      let output4 = await drawRandomOutput()
      await new Promise((resolve) => setTimeout(resolve, 750));


      let photo1 = document.getElementById('photo_1') as HTMLElement;
      output1.style.width = "100%";
      output1.style.objectFit = "cover";
      photo1.appendChild(output1);

      let photo2 = document.getElementById('photo_2') as HTMLElement;
      output2.style.width = "100%";
      output2.style.objectFit = "cover";
      photo2.appendChild(output2);

      let photo3 = document.getElementById('photo_3') as HTMLElement;
      output3.style.width = "100%";
      output3.style.objectFit = "cover";
      photo3.appendChild(output3);

      let photo4 = document.getElementById('photo_4') as HTMLElement;
      output4.style.width = "100%";
      output4.style.objectFit = "cover";
      photo4.appendChild(output4);

      this.print = true;

      // draw canvas
      let outputCanvas = document.getElementById('outputCanvas') as HTMLCanvasElement;
      outputCanvas.width = 1080;
      outputCanvas.height = 1920;
      let ctx = outputCanvas.getContext('2d');

      if (!ctx) return;
      let bgImg = "/img/bg.png"
      // draw in bg
      let bg = new Image();
      bg.src = bgImg;
      bg.onload = () => {
        ctx?.drawImage(bg, 0, 0, outputCanvas.width, outputCanvas.height);
        // let output5 = await drawRandomOutput()

        drawAtAngle(outputCanvas, output1, -6, 80, 500); // top left
        drawAtAngle(outputCanvas, output2, 6, 540, 500); // top right

        drawAtAngle(outputCanvas, output3, 6, 80, 1000); // bottom left
        drawAtAngle(outputCanvas, output4, 0, 540, 1000); // bottom right

        // write "sv.wemake.pe" a the bottom of the canvas on the center
        ctx.font = "bold 42px Space Grotesk";
        ctx.fillStyle = "rgb(185 28 28)";
        ctx.textAlign = "center";
        ctx.fillText("https://sv.wemake.pe", outputCanvas.width / 2, outputCanvas.height - 50);
      }

      // // center
      // drawAtAngle(outputCanvas, output5, 6, 500, 800); // bottom left
    },
    async shareToIg() {
      const canvas = document.getElementById('outputCanvas') as HTMLCanvasElement;
      const imageData = canvas.toDataURL("image/jpeg");
      const blob = await (await fetch(imageData)).blob();
      const filesArray = [
        new File([blob], `wm-san-valentin.jpg`, {
          type: blob.type,
          lastModified: new Date().getTime()
        })
      ];
      const shareData = {
        files: filesArray,
        title: 'We Make San Valentin',
        text: '¡Feliz San Valentín! 🥰',
      };
      try {
        await navigator.share(shareData);
      } catch (err) {
        if (confirm("Hubo un problema al compartir a IG desde tu navegador ¿Quieres descargar la imagen?")) {
          this.downloadImage();
        }
      }

    },
    downloadImage() {
      const canvas = document.getElementById('outputCanvas') as HTMLCanvasElement;
      let imageData = canvas.toDataURL("image/jpeg")

      let link = document.createElement("a")
      link.download = `wm-san-valentin.jpg`;
      link.href = imageData;
      link.click();
    }

  },
});
</script>
<style>
.landing{
  background-size: auto 100vh;
  @apply absolute left-[-55vh] scale-75 object-cover h-screen w-[1920px] hover:scale-105 cursor-pointer transition-transform duration-500; 
}
</style>
